import React, { ReactNode } from "react";
import styled from "styled-components";
import Legend from "@charty/legend";
import { Item } from "@charty/legend/item/model";
import Tooltip from "@charty/tooltip/histogram";
import { Range } from "@linkfluence/models/date";
import { Locale } from "@linkfluence/models/locale";
import { useTotal } from "./data";

export type LegendItem = {
  id: string;
  label: string;
  count: number;
  color: string;
};

export interface LegendProps {
  series: Item[];
  setHovered: (uid: string) => void;
  onClickLegend: (uid: Item["id"]) => void;
  tooltip?: (serie: Item, total: number) => ReactNode;
  total?: number;
  range: Range;
  locale: Locale;
  disableAnimation?: boolean;
  displayVolumes?: boolean;
}

const StyledLegend = styled(Legend)`
  margin-bottom: 12px;
`;

const StreamChartLegend = React.memo(
  ({
    series,
    setHovered,
    locale,
    onClickLegend,
    tooltip,
    total,
    range,
    disableAnimation,
    displayVolumes,
  }: LegendProps) => {
    const _total = useTotal(total, series);
    const _onClickSerie = onClickLegend
      ? (id: Item["id"]) => onClickLegend(id)
      : null;

    return (
      <StyledLegend
        items={series as LegendItem[]}
        setHovered={setHovered}
        align="left"
        locale={locale}
        onClickSerie={_onClickSerie}
        tooltip={
          tooltip
            ? (serie) => tooltip(serie, _total)
            : (serie) => (
                <Tooltip
                  count={serie.count}
                  label={serie.label}
                  color={serie.color}
                  locale={locale}
                  range={range}
                  total={_total}
                />
              )
        }
        disableAnimation={disableAnimation}
        displayVolumes={displayVolumes}
      />
    );
  }
);

export default StreamChartLegend;
